module.exports = __webpack_public_path__ + "static/assets/logo-light.286eb055.svg";